// based on rc-rate 2.5.0
import Rate from './src/';
export default Rate;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-rate/index.js
// module id = 841
// module chunks = 0